<template>
    <div class="datablends-table">
        
        <div class="mb-3 table-card">
            <div class="card-header px-0">
                <div class="row">
                    <div class="col-6">
                        <h3 class="mt-2">Data Blends ({{ local_datablends.length }})</h3>
                    </div>
                    <div class="col-6 text-end">
                        <button class="btn btn-secondary" @click="clearCache">Clear Client Cache</button>
                    </div>
                </div>
            </div>
            <div class="overflow-table p-0">
                <div class="table-width-responsive">  
                    <table class="table table-with-pagination mb-0">
                        <thead>
                            <tr>
                                <th class="align-middle d-table-cell column-sort-disabled">Data Blend Type</th>
                                <th class="align-middle d-none d-sm-table-cell column-sort-disabled">Status</th>
                                <th class="align-middle d-none d-xl-table-cell column-sort-disabled">Messages</th>
                                <th class="align-middle d-none d-md-table-cell">Last Refreshed</th>
                                <th class="align-middle d-table-cell column-sort-disabled pe-3" width="1">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(set, index) in list_shown" :key="set.id">
                                <td class="d-table-cell">
                                    {{ propercase(set.type) }}
                                </td>
                                <td class="d-none d-sm-table-cell">
                                    <span v-if="set.last_sync?.status === 'failed'" class="badge bg-red bg-icon-danger">Error</span>
                                    <span v-else-if="set.last_sync?.status === 'processing'" class="badge badge-primary">Processing</span>
                                    <span v-else-if="!set.last_sync && !set.type.includes('benchmark')" class="badge badge-secondary">Initializing</span>
                                    <span v-else class="badge bg-green bg-icon-success">Active</span>
                                </td>
                                <td v-if="set.last_sync?.status === 'failed'" class="align-middle d-none d-xl-table-cell">
                                    The last attempt to compile this Data Blend failed, likely due to a mapping issue. Return to your system under Connections>View Connections>Inclusion Filters or Column Mappings. The errored column(s) will be highlighted in red.
                                </td>
                                <td class="d-none d-xl-table-cell" v-else>

                                </td>
                                <td class="align-middle d-none d-md-table-cell">
                                    <span :title="datetime(set.last_processed_at)" data-bs-toggle="tooltip">
                                        {{ date(set.last_processed_at) }}
                                    </span>
                                </td>
                                <td class="align-middle text-end d-table-cell pe-3" width="1" >
                                    <div class="dropdown d-flex justify-content-center" v-if="!set.type.includes('benchmark')">
                                        <button 
                                            class="btn btn-white btn-icon-only-md" 
                                            data-bs-toggle="dropdown" 
                                            data-bs-auto-close="true" 
                                            aria-expanded="false"
                                         aria-label="Button">
                                            <img class="icon" src="/img/icons/avid-icons/dots-vertical.svg" alt="More options" data-bs-toggle="tooltip" title="Actions">
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-primary dropdown-menu-end">
                                            <a class="dropdown-item" :href="`/audience/${client.url}/new?datablend=${local_datablends[index].id}`">
                                                <img 
                                                    class="icon" 
                                                    src="/img/icons/avid-icons/plus.svg" 
                                                    data-bs-toggle="tooltip" 
                                                    data-bs-placement="bottom" 
                                                    title="Add Audience"
                                                    alt="Add icon"
                                                >
                                                Add Audience
                                            </a>
                                            <a class="dropdown-item" :href="`/integrations/${client.url}/data_blend/${local_datablends[index].id}`">
                                                <img 
                                                    class="icon" 
                                                    src="/img/icons/avid-icons/edit.svg" 
                                                    data-bs-toggle="tooltip" 
                                                    data-bs-placement="bottom" 
                                                    title="Edit Data Blend"
                                                    alt="Edit icon"
                                                >
                                                Edit Custom Calculations
                                            </a>
                                            <a class="dropdown-item" href="#" @click.prevent="refreshDataBlend(local_datablends[index].id)">
                                                <img 
                                                    class="icon" 
                                                    src="/img/icons/avid-icons/sync.svg" 
                                                    data-bs-toggle="tooltip" 
                                                    data-bs-placement="bottom" 
                                                    title="Force Rebuild Data Blend"
                                                    alt="Sync icon"
                                                >
                                                Force Rebuild
                                            </a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot class="table-border-bottom-0">
                            <tr>
                                <td colspan="100%" class="py-0">
                                    <div class="table-pagination">
                                        <div class="table-pagination--group d-none d-md-flex">
                                            <div class="position-relative">
                                                <select class="form-select" v-model="num_per_page" @change="reloadPagination(local_datablends)" aria-label="Num Per Page">
                                                    <option value="5000">ALL</option>
                                                    <option v-for="num in num_per_page_options" :key="num" :value="num">{{ num }}</option>
                                                </select>
                                                <div class="select-display-text">
                                                    Showing {{ num_per_page === '5000' ? 'ALL' : num_per_page }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="table-pagination--group d-none d-lg-flex">
                                            {{ local_datablends.length == 0 ? '0' : item_interval }} of {{ local_datablends.length }}
                                        </div>

                                        <div class="table-pagination--group">
                                            <button v-if="page_count > 1" class="btn btn-secondary btn-icon-only-md me-1" @click="moveToPrevPage(local_datablends)" :disabled="page_index === 0" data-bs-toggle="tooltip" title="Previous page">
                                                <img class="icon" src="/img/icons/avid-icons/chevron-left.svg" alt="">
                                            </button>

                                            <div class="d-flex page-selector" v-if="page_index_array.length <= 3">
                                                <button v-for="page in page_index_array" :key="page" class="btn btn-none btn-icon-only-md" :class="page === (page_index + 1) ? 'current-page' : ''" @click="moveToPage(page, local_datablends)">
                                                    {{ page }}
                                                </button>
                                            </div>
                                            <div class="d-flex page-selector" v-else>
                                                <button v-for="page in page_index_array.slice(0,2)" :key="page" class="btn btn-none btn-icon-only-md" :class="page === (page_index + 1) ? 'current-page' : ''" @click="moveToPage(page, local_datablends)">
                                                    {{ page }}
                                                </button>

                                                <button v-if="page_index > 2" class="btn btn-none btn-icon-only-md text-nowrap" disabled>
                                                ...
                                                </button>
                                                <button v-if="page_index >= 2 && page_index < page_index_array.length -1" class="btn btn-none btn-icon-only-md current-page">
                                                    {{ page_index + 1 }}
                                                </button>

                                                <button v-if="page_index < page_index_array.length -2" class="btn btn-none btn-icon-only-md text-nowrap" disabled aria-hidden="true">
                                                ...
                                                </button>
                                                <button :class="page_index === (page_index_array.length -1) ? 'current-page' : ''" class="btn btn-none btn-icon-only-md" @click="moveToPage(page_index_array.length, local_datablends)" :key="page_index_array.length">
                                                    {{ page_index_array.length }}
                                                </button>
                                            </div>

                                            <button v-if="page_count > 1" class="btn btn-secondary btn-icon-only-md ms-1" @click="moveToNextPage(local_datablends)" :disabled="page_index === page_count -1" data-bs-toggle="tooltip" title="Next page">
                                                <img class="icon" src="/img/icons/avid-icons/chevron-right.svg" alt="">
                                            </button>
                                        </div>

                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>                    
                </div>
            </div>
        </div>

        <transition name="slide">
            <div v-if="notification_message" class="notification success">
                <span v-html="notification_message"></span>
                <a class="btn" @click="notification_message = ''">
                    <i class="fas fa-times-circle"></i>
                </a>
            </div>
        </transition>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import moment from 'moment';
import Swal from 'sweetalert2';
import { useNotifications } from '../../composables/useNotifications';
import tablePaginationMixin from '../../mixins/table_pagination';

export default defineComponent({
    name: 'DataBlends',
    components: { Swal },
    mixins: [tablePaginationMixin],
    setup() {
        const { showNotification } = useNotifications();
        return {
            showNotification
        };
    },
    props: {
        datablends: {
            type: Object,
            required: true
        },
        client: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
                local_datablends: [],
                source_type: 'data_blend',
                seg_id: -1,
                form: {
                    saving: false,
                    error: false
                },
                errors :{
                    name: "",
                    value: ""
                },
                notification_message: ""
        };
    },
    computed: {
        show_is_primary() {
            for(let i = 0; i < this.local_datasets.length; i++) {
                if(!this.local_datasets[i].is_primary) {
                    return true;
                }
            }
            return false;
        }
    },
    mounted() {
        this.local_datablends = Object.values(this.datablends);
        
        // Initialize pagination
        this.reloadPagination(this.local_datablends);

        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl));

        for (let i = 0; i < tooltipTriggerList.length; i++) {
            (function(index) {
                tooltipTriggerList[index].addEventListener('click', function() {
                    tooltipList[index].hide();
                });
                tooltipTriggerList[index].addEventListener('mouseleave', function() {
                    tooltipList[index].hide();
                });
            })(i);
        }

            // Subscribe to datablend updates for each datablend
            this.local_datablends.forEach(datablend => {
                window.Echo.channel(`datablend.${this.client.id}.${datablend.id}`)
                    .listen('.DataBlendUpdated', (e) => {
                        // Find and update the datablend in our local array
                        const index = this.local_datablends.findIndex(d => d.id === e.id);
                        if (index !== -1) {
                            this.local_datablends[index].last_sync = e.last_sync;
                            this.local_datablends[index].last_processed_at = e.last_processed_at;
                            this.$forceUpdate(); // Force a re-render
                            // Reload pagination after update
                            this.reloadPagination(this.local_datablends);
                        }
                    });
            });
        },
        beforeUnmount() {
            // Clean up Pusher subscriptions
            this.local_datablends.forEach(datablend => {
                window.Echo.leave(`datablend.${this.client.id}.${datablend.id}`);
            });
        },
        methods: {
        refreshDataBlend(data_blend_id) {
            window.axios.post('/api/data_blend/'+this.client.url + '/' + data_blend_id + "/refresh")
                .then(response => {
                    Swal.fire({
                        title: "The Data is Rebuilding",
                        text: "The data blend will be rebuilt and all audiences will be resynced within a few minutes.",
                        icon: "success",
                        customClass: {
                            popup: 'swal-success'
                        },
                    });
                });

            for(let i = 0; i < this.local_datablends.length; i++) {
                if(this.local_datablends[i].id === data_blend_id) {
                    this.local_datablends[i].last_sync = new Date();
                    this.local_datablends[i].last_sync.status = 'processing';
                    this.$forceUpdate();
                    // Reload pagination after update
                    this.reloadPagination(this.local_datablends);
                    break;
                }
            }
        },
        filterLogicIsValid() {
            this.errors.value = "";

            if(!this.$refs.filter.isFormValid()) {
                this.errors.filter = "Please enter values for all of the inputs above.";
                return false;
            }

            return true;
        },
        clearCache() {
            this.form.saving = true;
            window.axios.get('/api/client/' + this.client.url + "/clear_cache")
                .then(response => {
                    this.form.saving = false;
                    this.showNotification({
                        text: 'Client cache was cleared!'
                    });
                });
        }
    }
});
</script>
